import React from 'react';
import { Icon, IconProps } from './Icon';

export const DownloadIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon
      strokeWidth={1.5}
      viewBox="0 0 20 20"
      height="20"
      width="20"
      {...props}
    >
      <path
        d="M16.6663 12.2223V14.1667C16.6663 15.5474 15.5471 16.6667 14.1663 16.6667H5.83301C4.4523 16.6667 3.33302 15.5474 3.33301 14.1667L3.33301 12.2223M6.29597 8.51856L9.99967 12.2223M9.99967 12.2223L13.7034 8.51856M9.99967 12.2223V3.33337"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};
